"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const actionTypes_1 = require("./actionTypes");
function sendThunktankQueue(tankSlice, action) {
    return (dispatch, getState) => __awaiter(this, void 0, void 0, function* () {
        const queueState = getState().thunktank[tankSlice].queue;
        const shouldInitiate = queueState.length === 0;
        dispatch({
            type: actionTypes_1.THUNKTANK_ENQUEUE,
            slice: tankSlice,
            queuedAction: action
        });
        if (shouldInitiate) {
            let queueState = getState().thunktank[tankSlice].queue;
            while (queueState.length > 0) {
                const nextAction = queueState[0];
                yield dispatch(nextAction);
                dispatch({
                    type: actionTypes_1.THUNKTANK_UNQUEUE,
                    slice: tankSlice
                });
                queueState = getState().thunktank[tankSlice].queue;
            }
        }
    });
}
exports.default = sendThunktankQueue;
